import { BehaviorSubject, Subject } from 'rxjs';

export class NotificationCountUpdatedService {
  private notificationCountRefresh: boolean = false;
  notification: BehaviorSubject<boolean>;

  private notificationReadSubject = new Subject<void>();
  notificationRead$ = this.notificationReadSubject.asObservable();

  constructor() {
    this.notification = new BehaviorSubject(this.notificationCountRefresh);
  }

  setNewNotificationRefresh(newValue: boolean) {
    this.notification.next(newValue);
  }

  notifyNotificationRead() {
    this.notificationReadSubject.next();
  }
}